var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":`转发${_vm.appNameLabel}给好友`,"placement":"right-start"}},[_c('div',{staticClass:"client-share",on:{"click":_vm.copy}},[_c('div',[_c('img',{attrs:{"src":_vm.shareIcon,"alt":""}})]),_c('span',[_vm._v("爱心转发")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }